import DaisyBaseService from './../../../services/DaisyBaseService';

/**
 * this is the time service to check for delayed transfer orders
 **/
export default class TimeService extends DaisyBaseService {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.moment = $injector.get('moment');
	}
	
	/**
	 * check if order is delayed
	 * @param {date} date - date to check
	 * @param {integer} offset - offset
	 **/
	isDelayed(date, offset) {
		const nowMinusOffset = this.moment().subtract(offset, 'minutes');
		const isBefore = this.moment(date).isBefore(nowMinusOffset);
		return isBefore;
	}

	/**
	 * check if order is in time
	 * @param {date} date - date to check
	 * @param {integer} offset - offset
	 **/
	isInTime(date, offset) {
		const nowMinusOffset = this.moment().subtract(offset, 'minutes');
		const nowPlusOffset = this.moment().add(offset, 'minutes');
		const isBetween = this.moment(date).isBetween(nowMinusOffset, nowPlusOffset);
		return isBetween;
	}
}
